import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import BottomHeaderClippingById from '../HeaderOnlineMediaClippingByIdRetail/Bottom';
import TopHeaderClippingById from '../HeaderOnlineMediaClippingByIdRetail/Top';
import TopHeaderOfmClippingById from './Top';
import BottomHeaderOfmClippingById from './Bottom';

export const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: white;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderOfflineMediaClippingByIdRetail = () => {
  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Grid container>
        <Grid item sm={12}>
          <TopHeaderOfmClippingById />
        </Grid>
        <Grid item sm={12}>
          <BottomHeaderOfmClippingById />
        </Grid>
      </Grid>
    </HeaderWrapper>
  );
};

export default HeaderOfflineMediaClippingByIdRetail;
